export enum MessageTypeEnum {
  Advisory = 'ADVISORY',
  BulbInfo = 'ADDITIONAL_INFO',
  Danger = 'DANGER',
  Info = 'INFO',
  Success = 'SUCCESS',
  Warning = 'WARNING',
}
